import React, {Component} from 'react';
import {Form, FormLayout, TextField, Button, Card} from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider} from '@shopify/polaris';
import './recoverPassword.css'
import {reqResetPassword} from "../../api/index";
import memory from '../../utils/memory';
import { Redirect } from 'react-router-dom';
import logo from '../../assets/logo.png'


//登陆的路由组件
export default class RecoverPassword extends Component{
    
    constructor(props) {
        super(props);
        this.state = {
            email:'',
            password:'',
            password_confirmation:'',
            loading:false,
            token:''
        };
      }

    componentDidMount(){
        const { search } = this.props.location
        const paramsString = search.substring(1)
        const searchParams = new URLSearchParams(paramsString)
        const token = searchParams.get('token')
        const email = searchParams.get('email')
        this.setState({token:token, email:email})

    }

    handleSubmit = (event) => {
        if(this.state.password === '' || this.state.password_confirmation === '')
        {
            alert('Please input your new password and confirm it.');
            return false;
        }

        if(this.state.password.length < 8 || this.state.password_confirmation < 8)
        {
            alert('Password is too short (minimum is 8 characters)');
            return false;
        }

        if(this.state.password !== this.state.password_confirmation )
        {
            alert("Passwords don't match. Re-enter your password.");
            return false;
        }


        this.setState({loading:true});
        
        reqResetPassword(this.state.email, this.state.token, this.state.password, this.state.password_confirmation).then(
            response => {
                this.props.history.replace('/login');
            }
        ).catch(
            error => {
                alert(error.response.data.message);
                this.setState({loading:false});
            }
        )

    }

    render () {
        if(memory.user_info !== '{}')
        {
            return <Redirect to="/" />
        }

        return (
            <div className="recover-password">
                <AppProvider i18n={enTranslations}>
                        <Card sectioned>
                        <img className="logo" src={logo} alt='' />
                        <h1>Recover password</h1>
                        <h2>Enter your new password and confirm</h2>
                        <Form onSubmit={this.handleSubmit}>
                            <FormLayout>
                                <TextField
                                value={this.state.password}
                                label="New password"
                                type="password"
                                onChange={val => this.setState({password: val})}
                                />

                                <TextField
                                value={this.state.password_confirmation}
                                label="Confirm new password"
                                type="password"
                                onChange={val => this.setState({password_confirmation: val})}
                                />
                                
                                <Button loading={this.state.loading} primary submit>Save</Button>
                            </FormLayout>
                        </Form>
                        <p onClick={() => this.props.history.replace('/login')}>
                            Return to login
                        </p>
                        </Card>
                </AppProvider>
            </div>
        )
    }
}